import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from '../StyledModal';

import EnterSend from "../EnterSend";

import { NotificationManager } from 'react-notifications';

import axios from 'axios';

function MyModalDeleteAbo({IsModalOpened, onCloseModal, getInfoUser, allInfo, indexSelected}) {

  const [idCompte, setIdCompte] = React.useState('');
  const [idAbo, setIdAbo] = React.useState('');

  const handleSubmit = () => {
    if(IsModalOpened === true) {
      deleteAbo()
    }
  }

  function onModalClose(event) {
    onCloseModal(event, 3);
  }

  React.useEffect(() => {
    if(indexSelected !== undefined && indexSelected !== null && allInfo.length > 0) {
      if(allInfo[indexSelected] !== undefined) {
        setIdAbo(allInfo[indexSelected].id_abonnement)
        setIdCompte(allInfo[indexSelected].id_compte)
      }
    }
  }, [allInfo, indexSelected]);

  function deleteAbo() {
    if(idAbo !== '' && idCompte !== '') {
      const formData = new FormData();
      formData.append('id_abonnement', idAbo)

      axios.post('https://eps.acces-editions.com/api/deleteAbonnement', formData)
      .then((res) => {
        if(res.status === 200)
        {
          NotificationManager.success('Abonnement supprimé', '', 3000);
          onModalClose(true)
          getInfoUser(idCompte)
        } else {
          NotificationManager.error('Une erreur s\'est produite', '', 3000);
        }
      })
    } else {
      NotificationManager.error('Erreur saisie dans les champs', '', 3000);
    }
  }

  return (
    <>
      <Modal size="md" active={IsModalOpened} toggler={() => {return}}>
        <ModalHeader toggler={() => onModalClose(false)}>
          Suppression abonnement
        </ModalHeader>
        <ModalBody>
          <div style={{ textAlign: 'center' }}>
            <div className="mb-6 grid grid-cols-2 gap-4">
              <label className="col-span-2 block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
                Suppression abonnement
              </label>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
            <Button 
                color="red"
                buttonType="link"
                onClick={(e) => onModalClose(false)}
                ripple="dark"
            >
              Fermer
            </Button>
            <Button
                color="green"
                onClick={(e) => deleteAbo()}
                ripple="light"
            >
              <EnterSend handleSubmit={handleSubmit}/>
              Valider
            </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default MyModalDeleteAbo;
